// Shared shell for a nav tab that has its own route/page but no design yet.
// Each page in src/Pages/public/pages that renders this is still its own
// file/component — this just avoids repeating the empty-state chrome five
// times until each tab's real layout lands.
export default function PlaceholderPage({ title, description }) {
  return (
    <section className="mx-auto max-w-3xl px-20 py-20 text-center sm:px-20">
      <h1 className="mt-3 font-radley text-3xl text-gray-900">{title}</h1>
      <p className="mt-4 text-sm text-gray-600">{description}</p>
    </section>
  );
}
